export default {
  name: 'track-data',
  props: {
    trackData: {
      type: Object,
      required: true
    },
    customDataLayer: {
      type: Object
    },
    executeOnce: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    scope() {
      return {
        track: this.track
      }
    }
  },
  mounted() {
    if (!this.$scopedSlots.default) {
      this.track()
    }
  },
  methods: {
    track() {
      if (this.executeOnce && this.trackData.eventName) {
        let additionalParameter = 'key'
        if (this.trackData.eventName === 'purchase') {
          additionalParameter = String(this.trackData?.reservation?.transactionID || 'key')
        }
        const uniqueKey = `initialTrackFired_${this.trackData.eventName}_${additionalParameter}`

        if (sessionStorage.getItem(uniqueKey)) {
          return
        }
        sessionStorage.setItem(uniqueKey, 'true')
      }

      if (this.customDataLayer && window.dataLayer) {
        window.dataLayer.push(this.customDataLayer)
      }

      this.$track(this.trackData)
    }
  },
  render(h) {
    const f = this.$scopedSlots.default || ((props) => {
      return h('span', { class: 'track-data', style: { display: 'none' }});
    })
    return f(this.scope)
  }
}
